import { render, staticRenderFns } from "./AddModalSchool.vue?vue&type=template&id=5cc89daa&scoped=true"
import script from "./AddModalSchool.vue?vue&type=script&lang=js"
export * from "./AddModalSchool.vue?vue&type=script&lang=js"
import style0 from "./AddModalSchool.vue?vue&type=style&index=0&id=5cc89daa&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc89daa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5cc89daa')) {
      api.createRecord('5cc89daa', component.options)
    } else {
      api.reload('5cc89daa', component.options)
    }
    module.hot.accept("./AddModalSchool.vue?vue&type=template&id=5cc89daa&scoped=true", function () {
      api.rerender('5cc89daa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/member/AddModalSchool.vue"
export default component.exports